import React, {ReactElement} from 'react';
import {StyledShapeSelectorContainer, StyledShapeSelector} from './styles';
import Props from './typings';

const shapeTypes = ['landscape', 'portrait', 'square'];

const ShapeSelector = ({selected, callback}: Props): ReactElement => {
  return (
    <StyledShapeSelectorContainer>
      {shapeTypes.map((shape) => (
        <StyledShapeSelector
          key={shape}
          className={`shapeItem ${selected.includes(shape) ? 'selected' : ''}`}
          onClick={() => callback(shape)}
        >
          <div className={shape}></div>
          <div className="shapeLabel">{shape}</div>
        </StyledShapeSelector>
      ))}
    </StyledShapeSelectorContainer>
  );
};
export default ShapeSelector;
